import { AHText, Box } from "arkh";
import { Image } from "expo-image";
import { graphql, useFragment } from "react-relay";
import * as React from "react";
import { ProductHeader_ProductDetails$key } from "./__generated__/ProductHeader_ProductDetails.graphql";

export function ProductHeader(props: {
  product: ProductHeader_ProductDetails$key;
}) {
  const product = useFragment(
    graphql`
      fragment ProductHeader_ProductDetails on ProductDetails {
        imageUrl
        partNumber
        name
      }
    `,
    props.product
  );

  return (
    <React.Fragment>
      {product.imageUrl ? (
        <Box spaceTop="medium" color="surface-primary">
          <Image
            source={{ uri: product.imageUrl }}
            contentFit="contain"
            style={{ height: 140 }}
          />
        </Box>
      ) : null}
      <Box color="surface-primary" spaceTop="medium" spaceBottom="medium">
        {product.partNumber ? (
          <AHText
            type="subtitle"
            color="washedText"
            spaceRight="xsmall"
            spaceHorizontal="medium"
          >
            {product.partNumber}
          </AHText>
        ) : null}
        <Box
          style={{
            flexDirection: "row",
            alignItems: "center",
          }}
          spaceHorizontal="medium"
        >
          <AHText type="title-big">{product.name}</AHText>
        </Box>
      </Box>
    </React.Fragment>
  );
}
